var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1024 1024",
    style: {
      enableBackground: "new 0 0 1024 1024"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M445.22,242.53L356.17,80.84H0v680.78c0,99.85,80.14,181.54,178.09,181.54h667.83 c97.95,0,178.09-81.69,178.09-181.54V242.53H445.22z M970.11,761.62l-0.29,8.72c-4.42,66.27-58.79,118.93-123.9,118.93H178.09 l-8.43-0.3C105.55,884.46,53.89,829,53.89,761.62V134.74h270.39l89.09,161.68h556.73V761.62z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.52,786.04l350.14-205.96L381.52,374.12V786.04z M435.36,468.29l189.92,111.78L435.36,691.79V468.29z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.629a3a484df6744b2f5233b7aea1cbde.svg";
export { ForwardRef as ReactComponent };